export const fmtMoney = (v) =>
  "$" + Number(v || 0).toLocaleString("en-AU", {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });

export const STATUS_BADGE = {
  draft: "bg-zinc-100 text-zinc-700 border-zinc-200",
  sent: "bg-blue-50 text-blue-800 border-blue-200",
  partially_paid: "bg-amber-50 text-amber-800 border-amber-200",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-200",
  voided: "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export const STATUS_LABEL = {
  draft: "Draft",
  sent: "Sent",
  partially_paid: "Part paid",
  paid: "Paid",
  voided: "Voided",
};

export const PAY_METHODS = [
  { value: "eft", label: "Bank transfer (EFT)" },
  { value: "eftpos", label: "EFTPOS terminal (CommBank)" },
  { value: "cash", label: "Cash" },
  { value: "cheque", label: "Cheque" },
  { value: "other", label: "Other" },
];
